import { install, ref, reactive, defineComponent } from 'vue-demi'
install();

import { VueRecaptcha } from "vue-recaptcha";
Vue.component('vue-recaptcha', VueRecaptcha);